import { PowerIcon } from './PowerIcon';

/**
 * author: Google
 * id C945D203-9737-4C25-87CA-29D97B862DD2
 * name power
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power.svg
 * tags
 * - Home Automation 
 */
export const ShutdownIcon = PowerIcon;
export default ShutdownIcon